import { render, staticRenderFns } from "./OrdersPagination.vue?vue&type=template&id=4a259622&"
import script from "./OrdersPagination.vue?vue&type=script&lang=js&"
export * from "./OrdersPagination.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports